package components.wrapper

import components.menus.sidebar.Sidebar
import components.menus.topbar.Topbar
import components.routing.ProtectedRoutingProps
import csstype.*
import kotlinx.browser.window
import mui.material.*
import mui.system.sx
import react.FC
import react.useState
import theme.Colors

val Wrapper = FC<ProtectedRoutingProps>("ContentWrapper") { props ->
    // state hooks
    val (showSidebarState, setShowSidebarState) = useState(true)

    // vars
    val bodyContainer = window.document.body ?: undefined

    Box {
        sx {
            height = 100.vh
            width = 100.vw
            overflow = Overflow.hidden
        }

        Box {
            CssBaseline()

            Topbar {
                session = props.session
                showSidebar = showSidebarState
                showSidebarSetter = setShowSidebarState
            }

            Sidebar {
                session = props.session
                sessionSetter = props.sessionSetter
                darkMode = props.darkMode
                container = bodyContainer
                showSidebar = showSidebarState
            }
        }

        Box {
            sx {
                if (showSidebarState) {
                    marginLeft = 300.px
                    width = 100.pct - 300.px
                } else {
                    width = 100.pct
                }
                position = Position.absolute
                top = 64.px
                height = (100.pct - 64.px)
                padding = 10.px
                overflowY = Auto.auto
                backgroundColor = Color(Colors.General.grey)

            }
            +props.children
        }

    }
}